// import { QuoteAssistService } from '../services/quote.assist.service';
import { DirectRfq, RfqPart } from './direct-quote-assist/direct.rfq.model';
import { DirectQuoteAssistService } from '../services/direct.quote.assist.service';
import { BaseComponent } from './base.component';

export class DirectQuoteBaseComponent extends BaseComponent {
  isTrackingEnabled:string='false';
  paymentTermList: any[]
  showPageDataLoading: boolean = false;
  trackingModel: any;
  constructor() {
    super();
    let paymentTermList = [];//creating variable so that on each add rendering does not start
    paymentTermList.push({ id: 0, displayText: "Select Payment Term", code: "", default: true });
    paymentTermList.push({ id: 1, displayText: "Net 15", code: "Net 15" });
    paymentTermList.push({ id: 2, displayText: "Net 30", code: "Net 30" });
    paymentTermList.push({ id: 3, displayText: "Net 45", code: "Net 45" });
    paymentTermList.push({ id: 4, displayText: "Net 60", code: "Net 60" });
    this.paymentTermList = paymentTermList;
  }

    tryParseFloat(value: any, defaultValue: number = 0): number {
      if (value === null || value === undefined) {
          // console.warn(`Value is null or undefined. Using default value: ${defaultValue}`);
          return defaultValue;
      }
      const strValue = String(value).trim();
  
      const parsedValue = parseFloat(strValue);
  
      if (!isNaN(parsedValue)) {
          return parsedValue; 
      }
  
      console.warn(`Failed to parse value: "${value}". Using default value: ${defaultValue}`);
      return defaultValue;
    }
  
    tryParseInt(value: any, defaultValue: number = 0): number {
      if (value === null || value === undefined) {
          console.warn(`Value is null or undefined. Using default value: ${defaultValue}`);
          return defaultValue;
      }
      const strValue = String(value).trim();
  
      const parsedValue = parseInt(strValue);
  
      if (!isNaN(parsedValue)) {
          return parsedValue; 
      }
  
      console.warn(`Failed to parse value: "${value}". Using default value: ${defaultValue}`);
      return defaultValue;
    }

  parseToFloatWithTwoDecimals(value: string | number | null | undefined): number | null {
    // Handle null, undefined, or empty string
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    // Convert the input to a string and trim whitespace
    const stringValue = String(value).trim();

    // Use regex to validate if the string is a valid number (including optional decimal points)
    const numericRegex = /^-?\d*\.?\d+$/;
    if (!numericRegex.test(stringValue)) {
      return 0; // Return null for invalid input
    }

    // Parse the value as a float
    const numericValue = parseFloat(stringValue);

    // Ensure exactly two decimal places
    return parseFloat(numericValue.toFixed(2));
  }

  parseToInteger(value: string | number | null | undefined): number | null {
    // Handle null, undefined, or empty string
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // Convert the input to a string and trim whitespace
    const stringValue = String(value).trim();

    // Use regex to validate if the string is a valid integer (optional negative sign allowed)
    const integerRegex = /^-?\d+$/;
    if (!integerRegex.test(stringValue)) {
      return 0; // Return null for invalid input
    }

    // Parse the value as an integer
    return parseInt(stringValue, 10);
  }

  isNotEmptyString(val: null | undefined | string | number): boolean {
    return !!val && val.toString().trim().length > 0;
  }

  isNullOrBlankOrEmpty(val: null | undefined | string | number): boolean {
    return !val || val.toString().trim().length === 0;
  }

  isNullOrBlankOrZero(value: null | undefined | string | number): boolean {
    if (this.isNullOrBlankOrEmpty(value)) {
      return true;
    }
    const numericValue = Number(value);
    return numericValue === 0 && !isNaN(numericValue);
  }

  isValidString(value: any): boolean {
    const strValue = String(value).trim();
    return strValue.length > 0;
  }

  addTracking(quoteAssistService: DirectQuoteAssistService, trackModule: string, trackEvent: string, currentPart: RfqPart, rfqData: DirectRfq,
    mixPanelEvent: string, queryParams: any,  dataToSend: any = {}
  ){
    if(this.isTrackingEnabled=='false'){
      return;
    }
    this.trackingModel = this.createEventModel(rfqData.companyId, rfqData.supplierId, rfqData.rfqId, trackModule, trackEvent,
      currentPart.rfqPartId, "", queryParams.integration);
    // this.trackingModel = this.createEventModel(rfqData.companyId, rfqData.supplierId, rfqData.rfqId, trackModule, trackEvent,
    //   currentPart.rfqPartId, currentPart.pdfFiles ? currentPart.pdfFiles[0].fileUrl : "", queryParams.integration);
    this.saveTrackingData(quoteAssistService, this.trackingModel);

    //MixPanel Tracking
    if (window.parent && mixPanelEvent) {
      let dataToEmit: any = Object.assign({ isQuoteAssistTracking: true }, queryParams);
      dataToEmit = Object.assign(dataToEmit, dataToSend)
      dataToEmit["eventName"] = mixPanelEvent;
      window.parent.postMessage(dataToEmit, "*");
    }
  }

  createEventModel(
    companyId: number,
    contactId: number,
    rfqId: string,
    eventType: string,
    eventAction: string,
    partId: string,
    partFile: string,
    source: string
  ): any {
    const eventId = this.generateEventId();
    const eventDatetime = (Math.floor(Date.now() / 1000)).toString();
    const eventData = {
      partId: partId,
      partFile: partFile
    };

    return {
      companyId: companyId,
      contactId: contactId,
      rfqId: rfqId + "#" + eventAction + "_" + eventDatetime,
      eventId: eventId,
      eventType: eventType,
      eventAction: eventAction,
      eventDatetime: eventDatetime,
      eventData: eventData,
      source: source
    };
  }
  generateEventId(): string {
    const timestamp = Date.now();
    return `event_${timestamp}`;
  }

  saveTrackingData(quoteAssistService: DirectQuoteAssistService, trackingData: any) {
    const payload = {
      ContactId: trackingData.contactId,
      CompanyId: trackingData.companyId,
      RfqId_EventId: trackingData.rfqId,
      EventAction: trackingData.eventAction,
      EventData: JSON.stringify(trackingData.eventData),
      EventDatetime: new Date().toISOString(),
      EventType: trackingData.eventType,
      Source: trackingData.source
    };
    

    quoteAssistService.saveTrackingData(payload).subscribe({
      next: (response: number) => {
        // console.log("Event tracking success");
      },
      error: (error: any) => {
        console.error('Error tracking event: ', error);
      }
    });
  }
  formatNumbersToFixed2(obj: any): any {
    if (typeof obj === 'number') {
      // Convert number to fixed-point with 2 decimal places
      return this.tryParseFloat(obj.toFixed(2));
    } else if (Array.isArray(obj)) {
      // Recursively process each element in the array
      return obj.map(item => this.formatNumbersToFixed2(item));
    } else if (typeof obj === 'object' && obj !== null) {
      // Recursively process each key-value pair in the object
      const formattedObj: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          formattedObj[key] = this.formatNumbersToFixed2(obj[key]);
        }
      }
      return formattedObj;
    }
    // Return non-number, non-object, non-array values as they are
    return obj;
  }
  
  parseAndFormat(value: any): number{
    return this.tryParseFloat(this.formatNumbersToFixed2(value));
  }
}